<template>
  <div>
    <div class="article-detail">
      <h1>{{ articleDetail.title }}</h1>
      <div class="info">
        <span>{{ articleDetail.papername | formatPaperName }}</span>
        <span v-if="articleDetail.updatetime">{{
          formatDate(articleDetail.updatetime)
        }}</span>
        <span class="heat"
          >热度<i>{{ parseFloat(articleDetail.degree).toFixed(2) }}</i></span
        >
        <div class="link">
          <a :href="articleDetail.url" target="_blank"
            ><i class="el-icon-connection"> 查看原文</i></a
          >
        </div>
      </div>
      <div class="text" v-html="articleDetail.contenttxt"></div>
    </div>
  </div>
</template>
<script>
import eventBus from "@/pages/EventBus";
import { GetJfrbArticle } from "@/api/index.js";
import { set } from "lodash";
import { formatPaperName } from "@/filters/index.js";

export default {
  name: "articleDetails",
  filters: {
    formatPaperName
  },
  data() {
    return {
      articleDetail: {},
      articleID: null,
      highlightData: null,

      complete: false
    };
  },
  activated() {},
  watch: {},
  mounted() {
    // console.log("eventBus", "mounted");
    // // 监听事件
    // eventBus.$on("pushMsg11", (data) => {
    //   console.log(111111);
    //   console.log("eventBus", data);
    // });
    // console.log(222222);
    this.getArticle();
  },
  created() {},
  // 确保在组件销毁前移除事件监听器
  beforeDestroy() {
    // eventBus.$off("pushMsg", highlightData);
  },

  methods: {
    scrollToHighlight() {
      // 获取所有带有'highlight'样式的元素
      var highlights = document.querySelectorAll(".highlight");

      // 检查是否有元素被选中
      if (highlights.length > 0) {
        // 滚动到第一个'highlight'元素，并且实现向上偏移60px
        const highlight = highlights[0];
        const yOffset = -65; // 向上偏移60px

        // 获取当前页面的滚动位置
        const y = window.pageYOffset || document.documentElement.scrollTop;

        // 计算最终滚动到的位置
        const finalTop = highlight.getBoundingClientRect().top + y + yOffset;

        // 使用scroll行为平滑滚动到计算后的位置
        window.scrollTo({
          top: finalTop,
          behavior: "smooth"
        });
      } else {
        console.log("没有找到带有highlight样式的元素");
      }
    },
    getArticle() {
      let highlightData = sessionStorage.getItem("highlightData");
      // 把字符串["11111","22222"]转为数组
      highlightData = JSON.parse(highlightData);

      const url = new URL(window.location.href);
      this.articleID = url.pathname.split("/").pop(); // 获取最后一个路径片段
      GetJfrbArticle({ id: this.articleID })
        .then((res) => {
          this.articleDetail = res.data;

          let html = this.brightenKeyword(res.data.contenttxt, highlightData);
          // console.log("@@@@", html);
          this.articleDetail = {
            ...res.data,
            contenttxt: html
          };

          setTimeout(() => {
            this.scrollToHighlight();
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    formatDate(time) {
      // 截取时间，不需要毫秒
      return time.substring(0, 19);
    },

    brightenKeyword(_html, data) {
      let keys = data;

      if (_html) {
        keys.forEach((item, index) => {
          if (item) {
            var reg = new RegExp("(<[^>]*?)(" + item + ")([^<]*?>)", "gmi");
            var _htmlMatch = _html.match(reg);
            if (_htmlMatch) {
              _htmlMatch.forEach(function (element) {
                console.log("element", element);

                var newHtml = element.replace(
                  new RegExp(item, "gmi"),
                  "!@#whhxdd!@#"
                );
                _html = _html.replace(element, newHtml);
              });
            }
            _html = _html.replace(
              new RegExp(item, "gmi"),
              '<font class="highlight">' + item + "</font>"
            );
            _html = _html.replace(/!@#whhxdd!@#/gi, item);
          }
        });
      }
      return _html;
    }
  }
};
</script>

<style lang="scss" scoped>
.article-detail {
  width: 960px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 200px;
  background: #fff;
  padding: 20px 80px;
  margin-top: 20px;
  border-radius: 8px;
  h1 {
    font-size: 28px;
    color: var(--text-1);
    margin-bottom: 5px;
  }
  .sidebar {
    position: absolute;
    left: -50px;
    top: 55px;
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        color: var(--text-3);
        i {
          font-size: 16px;
          margin-bottom: 5px;
        }
        span {
          font-size: 12px;
        }
        &:hover {
          color: var(--brand);
        }
      }
    }
  }
  .info {
    color: var(--text-3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      margin-right: 15px;
    }
  }
  ::v-deep .text {
    font-size: 17px;
    line-height: 1.6;
    color: var(--text-1);
    margin-top: 20px;
    padding-bottom: 120px;
    p {
      margin-bottom: 15px;
    }
  }
  ::v-deep img {
    width: 100%;
    border-radius: 6px;
  }
  ::v-deep video {
    width: 100%;
    margin: 0 auto;
  }
}

.fn-info-dialog-enter-active {
  animation: fn-fade-in 0.3s;
}
.fn-info-dialog-leave-active {
  animation: fn-fade-in 0.3s reverse;
}
@keyframes fn-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-4%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.info-item {
  border-bottom: 1px dashed #dddddd;
  h5 {
    font-size: 16px;
    font-weight: 500;
    margin: 20px 0 10px;
    color: var(--text-2);
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    li {
      color: var(--text-3);
      background: #ecf4ff;
      font-size: 14px;
      padding: 4px 6px;
      border-radius: 2px;
      margin-right: 4px;
      margin-bottom: 10px !important;
      cursor: default !important;
      &:hover {
        color: var(--text-3) !important;
      }
    }
  }
}

::v-deep .highlight {
  color: red;
}
.heat {
  margin-left: 40px;
  flex: 1;

  i {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #fe2d46;
    margin-left: 6px;
  }
}
</style>
